import { render, staticRenderFns } from "./SupplierRequirements.view.vue?vue&type=template&id=15c6ec5c&"
import script from "./SupplierRequirements.view.vue?vue&type=script&lang=js&"
export * from "./SupplierRequirements.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c6ec5c')) {
      api.createRecord('15c6ec5c', component.options)
    } else {
      api.reload('15c6ec5c', component.options)
    }
    module.hot.accept("./SupplierRequirements.view.vue?vue&type=template&id=15c6ec5c&", function () {
      api.rerender('15c6ec5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/update/protocol/SupplierRequirements.view.vue"
export default component.exports